import { createServiceDropdown } from "./fancy-dropdowns.d2d8f5945e1a.js";
import { buildAmplitudeClient } from "./custom-amplitude-client.303eb70a37e9.js";
import { ModalFilter } from "./filters/modal_filter.f7290363b78f.js";
import"./filters/index.93688a9e234c.js"; // Import file so we do not lose it in linting
import { ContactUs } from "./contact-us.b8b5aec961fd.js";
import { PriceVerification } from "./price-verification.f81a0cd32367.js";
import { CareQuality } from "./care-quality.b0953c39c01d.js";
import { MOBILE_SCREEN_QUERY, blurSortSelectOnMobileChange } from "./shared.1cf4cfaf2f6b.js";
import {
  OpenInsuranceSelectorEvent,
  InsuranceSelectorChangedEventType,
} from "./insurance-selector-events.87d20ca02104.js";
import { LocationSelectorChangedEventType } from "./location-selector.0800e0511ce1.js";
import { ServiceSelectorChangedEventType } from "./service-selector-events.5a616c64e072.js";
import { MobileMapController } from "./mobile-map-controller.3a4bd7871166.js";

class SearchPage {
  constructor() {
    this.rates = JSON.parse(document.getElementById("rates-data").textContent);
    if (!this.rates) throw new Error("unable to load embedded rates");

    this.elements = this.queryDomElements();
    this.mapController = new MobileMapController(
      document.getElementById("map-toggle"),
    );
    new ModalFilter();
    new PriceVerification();
    new CareQuality();
    this.amplitudeClient = buildAmplitudeClient();

    this.bindInputHandlers();
    if (this.elements.searchBarPopover) {
      this.amplitudeClient.setupSearchBarAnalytics(
        this.elements.searchBarPopover,
      );
    }
    this.bindFilterHandlers();
    this.bindEventListeners();
  }

  queryDomElements = () => {
    return {
      ratesForm: document.getElementById("rates-form"),
      openMobileSearchButton: document.getElementById("open-mobile-search"),
      closeMobileSearchButton: document.querySelectorAll(
        ".search-bar--popover .mobile-close",
      ),
      searchBarPopover: document.querySelector(".search-bar--popover"),
      checkCoverageLinks: document.querySelectorAll(".tqc-check-coverage"),
      modalForm: document.getElementById("all-filters-form"),
      exclusionsSwitch: document.getElementById("exclusions-switch"),
      packageInfoSection: document.getElementById("package-info-container"),
    };
  };

  bindEventListeners() {
    blurSortSelectOnMobileChange();
    document.body.addEventListener("htmx:afterSettle", (e) => {
      // Re-query and bind elements that may have been replaced by htmx swap
      this.elements = this.queryDomElements();
      this.bindInputHandlers();
      new ModalFilter();
      new PriceVerification();
      new CareQuality();
      // Reapply visibility state after all swaps complete
      this.mapController.updateMapVisibility(
        this.mapController.isMapVisibleOnMobile,
      );
    });
    const closeableEvents = [
      InsuranceSelectorChangedEventType,
      LocationSelectorChangedEventType,
      ServiceSelectorChangedEventType,
    ];
    for (const closeableEvent of closeableEvents) {
      document.addEventListener(closeableEvent, (e) => {
        if (MOBILE_SCREEN_QUERY.matches) {
          this.closeMobileSearchOverlay();
        }
      });
    }
  }

  bindInputHandlers() {
    if (this.elements.exclusionsSwitch) {
      this.elements.exclusionsSwitch.addEventListener(
        "change",
        this.exclusionsSwitchChange,
      );
    }
    if (this.elements.openMobileSearchButton) {
      this.elements.openMobileSearchButton.addEventListener(
        "click",
        this.openMobileSearchOverlay,
      );
    }
    this.elements.closeMobileSearchButton.forEach((button) => {
      button.addEventListener("click", this.closeMobileSearchOverlay);
    });
    this.elements.checkCoverageLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (MOBILE_SCREEN_QUERY.matches) {
          this.openMobileSearchOverlay();
          document.dispatchEvent(
            new OpenInsuranceSelectorEvent(false, {
              navMethod: "check-coverage",
            }),
          );
        } else {
          document.dispatchEvent(
            new OpenInsuranceSelectorEvent(true, {
              navMethod: "check-coverage",
            }),
          );
        }
        // I have a hypothesis that users wont use this,
        // so tracking its usage.
        this.amplitudeClient.trackEvent("workflow_started", {
          workflow: "check_coverage",
        });
      });
    });
  }

  bindFilterHandlers() {
    document.addEventListener("tq:resetfilter", (e) => {
      this.elements = this.queryDomElements();
      const form = e.target.id.includes("all-filters")
        ? this.elements.modalForm
        : this.elements.ratesForm;
      for (const [formKey, filterValue] of Object.entries(e.detail)) {
        let element = form.elements[formKey];
        if (element instanceof RadioNodeList) {
          // RadioNodeLists are a collection of radio/checkboxes. Using RadioNodeList#value= works for setting a value,
          // but not for unchecking a radio button. This is needed to reset `care_quality` to be unselected
          for (let input of element) {
            input.checked = input.value === filterValue;
          }
        } else {
          if (filterValue == "null") {
            element.value = null;
          } else {
            element.value = filterValue;
          }
        }
      }
      form.elements["action"].value = "filter";
      form.submit();
    });
  }

  exclusionsSwitchChange = (evt) => {
    let func = "remove";
    if (evt.target.checked) {
      func = "add";
    }

    // save this cookie for 30 days
    document.cookie = `consumer_price_verification_enabled=${
      evt.target.checked
    }; max-age=${60 * 60 * 24 * 30}`;
    const verifiers = document.querySelectorAll(".tqc-package-result-card");
    verifiers.forEach((verifier) => verifier.classList[func]("tqc-verified"));
  };

  openMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.remove("pv-hide-on-small");
    this.elements.searchBarPopover.classList.add("pv-inset-square-16");
  };

  closeMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.add("pv-hide-on-small");
    this.elements.searchBarPopover.classList.remove("pv-inset-square-16");
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new SearchPage();
});
